import { render, staticRenderFns } from "./LocationSettingsDevices.vue?vue&type=template&id=24edf1cc&scoped=true"
import script from "./LocationSettingsDevices.vue?vue&type=script&lang=js"
export * from "./LocationSettingsDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edf1cc",
  null
  
)

export default component.exports